module.exports = __webpack_public_path__ + "img/2.91f3e1fe.png";